import { useEffect, useState } from "react";
import API_BASE from "../config.js";
import { authFetch } from "../services/authFetch";
// So-leitura, so busca dado -- nenhum calculo de negocio nem apresentacao
// aqui (isso fica no componente que consome o hook). Nao dispara nada
// enquanto `ativo` for false: o radar vive dentro de um modal que so monta
// sob demanda (mesmo padrao do ModalBuscaExterna em Estoque.js), entao nao
// ha chamada nenhuma ate o usuario abrir a tela -- sem polling, sem custo
// extra pros paineis que ja estao em uso.
export default function useEstoqueRadar(tenantId, { ativo = true, dias = 30 } = {}) {
  const [status, setStatus] = useState("loading"); // loading | pronto | erro
  const [itens, setItens] = useState([]);
  useEffect(() => {
    if (!ativo || !tenantId) return;
    let cancelado = false;
    setStatus("loading");
    authFetch(API_BASE + "/api/v1/dados/estoque-radar/" + tenantId + "?dias=" + dias)
      .then((res) => { if (!res.ok) throw new Error("HTTP " + res.status); return res.json(); })
      .then((data) => {
        if (cancelado) return;
        setItens(Array.isArray(data) ? data : []);
        setStatus("pronto");
      })
      .catch(() => { if (!cancelado) setStatus("erro"); });
    return () => { cancelado = true; };
  }, [tenantId, ativo, dias]);
  return { status, itens };
}
